import { getAll } from '@/api/produit/produitImpressionAffiche';
import { NO_PAGINATION } from '@/configuration/clientTableConf';

export function getLibelle(idProduit, allProduitsImpressionAffiche) {
  const produit = allProduitsImpressionAffiche.find((produit) => {
    return produit.id === idProduit;
  });
  return produit ? produit.libelle : null;
}

export default async function getLibelleProduitImpressionAfficheDefaut(societe) {
  const produitIds = [
    societe.produitIdDefautVisuel,
    societe.produitIdDefautImpression,
    societe.produitIdDefautFaconnage,
    societe.produitIdDefautImpressionEtFaconnage,
  ].filter(Boolean);
  let allProduitsImpressionAffiche = [];
  if (!produitIds.length) allProduitsImpressionAffiche = [];
  else {
    allProduitsImpressionAffiche = (await getAll({
      orderBy: 'Libelle',
      ascending: true,
      query: {
        actif: null,
        ids: produitIds,
      },
      maxResultCount: NO_PAGINATION,
    })).data.result.items;
  }
  const produitImpressionAffiche = {
    visuel: getLibelle(societe.produitIdDefautVisuel, allProduitsImpressionAffiche),
    impression: getLibelle(societe.produitIdDefautImpression, allProduitsImpressionAffiche),
    faconnage: getLibelle(societe.produitIdDefautFaconnage, allProduitsImpressionAffiche),
    impressionEtFaconnage: getLibelle(societe.produitIdDefautImpressionEtFaconnage,
      allProduitsImpressionAffiche),
  };
  return produitImpressionAffiche;
}
